import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const removeFailedForCard = (cardId: OLO.CreditCards.CreditCardId) =>
    createSelector(creditCardsState, (creditCards) => creditCards.remove.hasFailed && creditCards.remove.id === cardId);
